module.exports = __webpack_public_path__ + "static/media/3.bf4430dd.png";